import axios from "axios";
import APILinks from "@/links/links";

export default {
  getAdminToken(roomName, participantName, meetingId) {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.get(
      APILinks.LIVEKIT_GET_ADMIN_TOKEN() +
        `?room_name=${roomName}&participant_name=${participantName}&meeting_id=${meetingId}`,
      { headers: headers }
    );
  },
  disableParticipantTrack(roomName, participantIdentity, trackSid) {
    const headers = {
      "Content-Type": "application/json",
    };
    return axios.get(
      APILinks.LIVEKIT_DISABLE_PARTICIPANT_TRACK() +
        `?room_name=${roomName}&participant_identity=${participantIdentity}&track_sid=${trackSid}`,
      { headers: headers }
    );
  },
};
